import { Component, Input } from '@angular/core';
import { IlsProvider } from '../../providers/ils/ils';
import { CoEmailInputComponent } from '../co-email-input/co-email-input';
import { CoBibItemProvider } from '../../providers/co-bib-item/co-bib-item';
import { PopoverController, LoadingController, ModalController, Keyboard } from 'ionic-angular';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { NavController } from 'ionic-angular/navigation/nav-controller';
import { CoCatalogSearchPage } from '../../pages/co-catalog-search/co-catalog-search';
import { AppState } from '../../config/state';
import { TypesenseProvider } from '../../providers/typesense/typesense';
import { LoginProvider } from '../../providers/login/login';
import { CoHoldPickupPopoverComponent } from '../co-hold-pickup-popover/co-hold-pickup-popover';
import { CoBibHoldingListModalPage } from '../../pages/co-bib-holding-list-modal/co-bib-holding-list-modal';
import { MailProvider } from '../../providers/mail/mail';
import { CoPopoverSearchFilterComponent } from '../co-popover-search-filter/co-popover-search-filter';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { OverdriveProvider } from '../../providers/overdrive/overdrive';

@Component({
  selector: 'co-catalog-search',
  templateUrl: 'co-catalog-search.html',
  inputs: ['blockInfo'],
})
export class CoCatalogSearchComponent {
  @Input('blockInfo') blockInfo: any;
  @Input('searchTerm') searchTerm: any;
  @Input('filters') presetFilters: any;
  @Input('overdriveEnabled') overdriveEnabled: any;
  private term: string;
  private activeTerm: string="";
  private activeTotal: number;
  private type: string;
  private page: number = 0;
  private start: number = 0;
  private limit: number = 12;
  private searching: boolean = false;
  private results: Array<any>;
  private keyword: string;
	// private filterParameters: any = {searchBy: 'full', filterBy: []};
	private filterParameters: any = {searchBy: this.state.searchSource === 'discover' ? 'full':'title', filterBy: [], sortBy: false};
	private patron: any;
	private showSearchImage: boolean = true;
	private filtersOn: boolean = false;
	private toggleFilterIndicator: number = 0;
	private shouldShowCancel: boolean;
  private searchLinks: Array<any>;
  private searchSource: string = 'ils';
  private overdriveFormats: Array<any> = [];
  private overdriveSearchSortTypes: Array<any> = [];
  constructor(private ils:IlsProvider, private bibItem:CoBibItemProvider, private popoverCtrl : PopoverController, private toast : ToastAlertsProvider, private navCtrl: NavController, private state: AppState, private typesense: TypesenseProvider, private loginProvider : LoginProvider, private loading :LoadingController, private modalCtrl : ModalController, private email : MailProvider, private keyboard : Keyboard, private browser:InAppBrowser, private overdrive: OverdriveProvider) {
    this.results=[];
    this.keyword = this.state.client.keyword;
		this.clear();
		this.filterParameters.searchBy = this.state.defaultSearchBy[0];
    this.searchLinks = this.state.searchLinks;
    // this.ils.getSearchTypes().then(res => {
		// 	// this.type = res.filter(e=> e.default)[0].type;
		// 	this.searchByList = res;
		// })
		// this.shouldShowCancel = this.state.cordovaAvailable;
  }

  ngOnInit() {
		if (this.presetFilters){
			this.filterParameters = this.presetFilters;
		}
    if (this.searchTerm) {
      this.term = this.searchTerm;
      this.search();
		}
    if(this.overdriveEnabled) {
      this.overdrive.getFormats().then( (formats) => {
        this.overdriveFormats = formats;
      });
      this.overdrive.getSearchSortTypes().then( (types) => {
        this.overdriveSearchSortTypes = types;
      })
    }
  }

  loadMoreItems(infiniteScroll) {
    this.search().then(status=>{
     infiniteScroll.complete();
    });

  }
  showBibItem(item){
    if(this.state.digitalServices.hoopla && item.src && item.src.toLowerCase() === 'hoopla') {
      this.bibItem.showItemFromBibId(item);
    } else if(this.state.digitalServices.overdrive && item.src && item.src.toLowerCase() === 'overdrive') {
      this.bibItem.showItemFromBibId(item);
    } else if(item.id) {
      this.bibItem.showItemFromBibId(item.id);
    } else {
      this.bibItem.showItemFromBibId(item);
    }
  }
  emailBookInfo(item){
    let customClass = 'custom-email-input-popover';
    let popover = this.popoverCtrl.create(CoEmailInputComponent, {}, {cssClass: customClass});
    popover.present({ev: ''});

    popover.onDidDismiss(email => {
			if (email && email.info) {
        let available;
        item.available? available = "YES" : available = "NONE AVAILABLE";
        let emails = [];
        emails.push({ email: email.info })
        let params = {email: email.info, template: "item_scan_information", phone: ''}
        let vars = {
          title: item.title,
          author: item.author,
          barcode: item.barcode || 'none',
          isbn: item.isbns[0] || 'none',
          upc: item.upcs[0] || 'none',
          available: available,
          description: item.summaries? item.summaries[0].text : ''
        }
        this.email.sendItemInfoEmail(params, vars);
        this.toast.showAlert('',`Details for '${item.title}' sent to ${email.info}!`,'success');
      }
    });
	}

	placeHold(item){
		this.loginProvider.requireLogin((pat) => {
      this.patron = pat;
      if (this.patron && this.patron.id) {
        this.ils.getPickupLocations().then(res => {
          if (res) {
            this.openHoldLocationPopup(res, item);
          } else {
            this.toast.showAlert('', 'Error handling request');
          }
        });
      }
    }, null, null, false);
	}

	titleCase(str) {
    return str.toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' ');
	}

	openHoldLocationPopup(list, book) {
    let holdsPopup = this.popoverCtrl.create(CoHoldPickupPopoverComponent, { locations: list, patron: this.patron }, { cssClass: 'place-holds-popover' });
    holdsPopup.present({ ev: '' });

    holdsPopup.onDidDismiss(info => {
      let title = this.titleCase(book.title);
      if (title.length > 30) title = title.split('').slice(0,30).join('') + "...";
      let loader = this.loading.create({
        content: 'Placing your hold...',
      });
        if (info && book.id) {
          // console.log(info, this.patron);
          loader.present();
          this.ils.placeHold(this.patron.barcode, this.patron.pin, book.id.toString(), info.location.code, 'b').then(res => {
            if (res && res.status) {
              // console.log('wee success')
              this.toast.triggerToast(`Request successful, you will be notified when ${title} is available at ${info.location.name}`, '', 'success');
              loader.dismiss().catch(err=>{});
            } else {
              loader.dismiss().catch(err=>{});
              this.toast.triggerToast(res && res.message ? res.message : 'Error placing your hold, please contact a librarian', '');
            }
          });
        } else if (info) {
          this.toast.triggerToast('Error finding a copy, please contact a librarian', '', 'warning');
        }
    });
  }

	findBookCopy(item){
		if (item.id) {
      this.ils.getBibHoldingInfo(item.id.toString()).then(ilsGetBibHoldings => {
        // console.log(ilsGetBibHoldings);
        if (ilsGetBibHoldings) {
          let doesLocationExist = ilsGetBibHoldings.filter(e => e.location !== null);
          if (doesLocationExist.length > 0){
            let holdsPopup = this.modalCtrl.create(CoBibHoldingListModalPage, { locations: ilsGetBibHoldings, bib: item }, {cssClass: "full-screen-modal"});
            holdsPopup.present({ ev: '' });

            holdsPopup.onDidDismiss(info => {
              if (info && info.placeHold) {
                this.placeHold(item);
              }
            });
          } else {
            this.toast.triggerToast('No locations found, please contact a librarian', '');
          }
        } else {
          this.toast.triggerToast('Error finding a copy, please contact a librarian', '');
        }
      });
    } else {
      this.toast.triggerToast('Error finding a copy, please contact a librarian', '');
    }
	}

  private clear($event?){
    this.searching = false;
    this.activeTerm = "";
  }
  public refresh(reset){
    if(reset) {
      if (this.presetFilters){
        this.filterParameters = this.presetFilters;
      } else {
        this.filterParameters =  { searchBy: this.state.searchSource === 'discover' ? 'full' : 'title', filterBy: [], sortBy: false };
      }
    }
    this.showSearchImage = false;
    this.start = 0;
    this.page = 1;
    this.results=[];
    this.searching = true;
    this.search();
  }
	public handleEnterPress(){
		console.log('keyboard closing');
		this.keyboard.close();
	}
    presentPopover(myEvent) {
        let customClass = '';
        this.state.mode === 'app' ? customClass = 'custom-popover-app' : customClass = 'custom-popover-desktop';

        const params: any = {
          current: this.filterParameters,
          searchSource: this.searchSource,
        };
        if(this.overdriveEnabled && this.searchSource === 'overdrive') {
          params.limitByTypes = this.overdriveFormats;
          params.sortByList = this.overdriveSearchSortTypes;
          params.searchByList = [];
          params.data = 'limitBy';
        }

        let popover = this.popoverCtrl.create(CoPopoverSearchFilterComponent, params, { cssClass: customClass });
          popover.present({
          ev: myEvent
        });

        popover.onDidDismiss(data => {
            let filterCount = 0;
            this.filtersOn = false;
            if(data) {
                this.filterParameters = {
                    filterBy: data.filterBy ? data.filterBy : [],
                    searchBy: data.searchBy ? data.searchBy : 'full',
                    sortBy: data.sortBy ? data.sortBy : 'RELEVANCE',
                    limitBy: data.limitBy ? data.limitBy : null
                };
            }
            if(data && data.filterBy && data.filterBy.length>0){
                this.filtersOn = true;
                filterCount += data.filterBy.length;
            }
            if(data && data.searchBy && data.searchBy.length>0){
                this.filtersOn = true;
                if (data.searchBy !== 'full') filterCount++;
            }
            if(data && data.sortBy){
                this.filtersOn = true;
                if (data.sortBy !== 'RELEVANCE') filterCount++;
            }
            if(data && data.limitBy){
                this.filtersOn = true;
                if (data.limitBy !== 'TOM=*') filterCount++;
            }
            if(data){
                this.refresh(false);
                this.toggleFilterIndicator = filterCount;
            }
        });
    }

  openExternalSearch(urlTemplate) {
    const url = urlTemplate.replace('{{searchTerm}}', encodeURIComponent(this.term));
    this.browser.create(url, '_system');
  }

  private search():Promise<boolean>{
    if (this.blockInfo && !this.blockInfo.embedded && this.term.length>0) {
      const od = this.blockInfo.settings && this.blockInfo.settings.overdrive;
      this.navCtrl.push(CoCatalogSearchPage, {searchTerm: this.term, overdriveEnabled: od});
      return;
		}
    if(this.term.trim()!==this.activeTerm){ //new search term, lets reset
      this.start = 0;
      this.page = 1;
      this.activeTerm = this.term.trim();
      this.results=[];
      this.searching = true;
	  }
    if (this.term.length > 0){
			if(this.state.searchSource==='discover' && this.searchSource==='ils'){
        try {
          return this.typesense.init().then(async () => {
            let filters: string = "";

            const searches = {
              searches: [{}]
            };
            const commonParams: any = {
              per_page: 20,
              page: this.page,
              q: this.activeTerm,
              preset: this.typesense.preset
            };

            this.filterParameters.filterBy.forEach( filter => {
              if(filters.length>0) {
                filters += ',' + filter;
              } else {
                filters += 'f:[' + filter;
              }
            });
            if(filters.length > 0) {
              filters += ']';
              commonParams.filter_by = filters;
            }

            if(this.filterParameters.searchBy){
              if(this.filterParameters.searchBy !== 'full'){
                commonParams.query_by = this.filterParameters.searchBy;
              }
              if(this.filterParameters.searchBy === 'ids.v'){
                commonParams.typo_tokens_threshold = 1;
              }
            }

            function mapHit(hit) {
              let overdrive = hit.ids.filter(a => a.n.toLowerCase() == 'overdrive');
              if (overdrive && overdrive[0]) hit.src = 'overdrive';
              return {
                "id": hit.objectID,
                "ids": hit.ids.map(id=>({type:id.n, id:id.v || id.id})),
                "title": hit.ti,
                "author": hit.pa,
                "authors": hit.cr ? hit.cr.filter(cr=>cr.r==='author').map(cr=>cr.n):[],
                "publisher": hit.pa,
                "publishYear": null,
                "pageCount": null,
                "averageRating": null,
                "ratingsCount": null,
                "readingModes": null,
                "available": true,
                "format": hit.f,
                "language": null,
                "previewLink": null,
                "imageLinks": null,
                "isbns": hit.ids.filter(id=>id.n==='ISBN').map(id=>id.v),
                "upcs": hit.ids.filter(id=>id.n==='UPC').map(id=>id.v),
                "subjects": hit.sb,
                "summaries": [hit.su],
                "series": [],
                "notes": [],
                "src": hit.src
              }
            }

            const { results } = await this.typesense.client.multiSearch.perform(searches, commonParams);

            if(results && results.length > 1) {
              const hits = results[1].grouped_hits.reduce(function(acc, cur) {
                var documents = cur.hits.map(function(h) {
                  return h.document;
                })
                return acc.concat(documents);
              }, []);
              this.activeTotal = results[1].found;
              this.page += 1;
              const mappedHits = hits.map(mapHit);
              this.results.push(...mappedHits);
            }
            this.searching = false;
            this.showSearchImage = false;
            return true;
          });
        } catch(e) {
          console.error(e);
          this.showSearchImage = true;
          this.searching = false;
					this.activeTotal = undefined;
          return new Promise(() => false);
        }
			} else if(this.searchSource === 'overdrive') {
        return this.overdrive.getSearchResults(this.activeTerm, this.limit, this.start, this.filterParameters.limitBy, this.filterParameters.sortBy).then( (res) => {
          this.showSearchImage = false;
          this.start += this.limit;
          if(res.total) this.activeTotal = res.total;
          this.results = this.results.concat(res.results);
          this.searching = false;
          return true;
        }).catch( (e) => {
          this.activeTotal = undefined;
					this.searching = false;
					return false;
        });
      } else {
				let a = this.state.searchByList.find(f =>{return f.name.toLowerCase() === this.filterParameters.searchBy.toLowerCase()});
				if (a) this.type = a.type;
				// console.log(this.type, this.selectedSortBy, this.selectedLimitBy, this.filterParameters)
				return this.ils.searchCatalog(this.activeTerm, this.start, this.limit, this.type, this.filterParameters.sortBy, this.filterParameters.limitBy).then(search=>{
					this.showSearchImage = false;
					if(search.term !== this.activeTerm)return false;
					this.start+=this.limit;
					if(search.total) this.activeTotal = search.total;
					this.results = this.results.concat(search.results);
					// console.log(this.results);
					this.searching = false;
					return true;
				}).catch(err =>{
					this.activeTotal = undefined;
					this.searching = false;
					return false;
				});
			}
	} else {
		this.searching = false;
	}
  }
}



// WEBPACK FOOTER //
// ./src/components/co-catalog-search/co-catalog-search.ts